import React from "react";
import Default from "./Default";

const Links = ({ }) => {
    return (
        <Default />
    )
};

export default Links;